// extracted by mini-css-extract-plugin
module.exports = {"errorInput":"Contact_errorInput__FXhsI","errorMessage":"Contact_errorMessage__9aKX2","invalid-form-group":"Contact_invalid-form-group__2LtJT"};